/**
 * TrustChip — the small shared chip for trust states: dq flags on cells
 * (KNOWN-WRONG / DQ), sign-off state in the DefinitionPopover, lock states
 * where an icon alone is not enough. Typed props only (CD-7).
 */

import React from 'react'
import clsx from 'clsx'

export type TrustTone = 'good' | 'warn' | 'bad' | 'info' | 'neutral'

const TONE_CLASSES: Record<TrustTone, string> = {
  good: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-400',
  warn: 'bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400',
  bad: 'bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400',
  info: 'bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-400',
  neutral: 'bg-slate-100 text-slate-600 dark:bg-slate-700/40 dark:text-slate-300',
}

interface TrustChipProps {
  tone: TrustTone
  label: string
  title?: string
}

export default function TrustChip({ tone, label, title }: TrustChipProps): React.JSX.Element {
  return (
    <span
      title={title}
      className={clsx(
        'inline-flex items-center rounded px-1 py-px text-[9px] font-semibold uppercase tracking-wide',
        TONE_CLASSES[tone]
      )}
    >
      {label}
    </span>
  )
}
